import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import errors from './errors.js'
import help from './help.js'
import info from './info.js'

export default contract({
  errors: array([
    errors
  ]),
  help: array([
    help
  ]),
  info: array([
    info
  ])
})
